import {
  AllUserMonarxDetails200RowsItem,
  SiteInfoResponseModelV2,
} from '@newfold/huapi-js/src/index.schemas';

import SiteDomainActions from './SiteDomainActions';

/* const MALWARE_ERROR_STYLE = {
  backgroundColor: 'error.50',
  accentColor: 'error.dark',
}; */

interface OverviewTopCapProps {
  hostingId: string;
  isListPage?: boolean;
  monarxDashboardData: AllUserMonarxDetails200RowsItem | undefined;
  siteInfo?: SiteInfoResponseModelV2;
  isAutogenPendingURL?: boolean;
  domainUpdateInProgress?: boolean;
  sitesDomainLoading?: boolean;
  wouldSiteDomainActionsShow?: boolean;
  onShouldShowManageButton?: (show: boolean) => void;
}

/* const openInNewTab = (url: string | null | undefined): void => {
  if (url) window.open(url, '_blank');
};
 */
const OverviewTopCap = ({
  hostingId,
  isListPage = false,
  monarxDashboardData,
  siteInfo = {},
  isAutogenPendingURL = false,
  domainUpdateInProgress = false,
  sitesDomainLoading = false,
  wouldSiteDomainActionsShow = false,
  onShouldShowManageButton = () => {},
}: OverviewTopCapProps) => {
  /*const { t } = useTranslation('site', { keyPrefix: 'malwareUpgradeBanner' });
  const [isReportDrawerOpen, setIsReportDrawerOpen] = useState(false);
  const { contactLink } = useBrandInfo();

  const {
    health_status: healthStatus,
    plan: planName,
    domain_name: domainName,
    addon_id: addonId,
    account_back_ref: accountBackRef,
  } = monarxDashboardData ?? {};

 const openReportDrawer = () => {
    setIsReportDrawerOpen(true);
  };

  const closeReportDrawer = () => {
    setIsReportDrawerOpen(false);
  };

  const planNameLower = planName?.toLowerCase() ?? '';
   const healthStatusLower = healthStatus?.toLowerCase() ?? '';
  const showThreatshieldBanner = isLevel3AndDetected({
    plan: planNameLower,
    healthStatus: healthStatusLower,
  });
  const showMalwareUpgradeBanner = shouldShowMalwareUpgrade({
    healthStatus: healthStatusLower,
    plan: planNameLower,
  });
 */
  /*   const reportDrawer = showThreatshieldBanner && (
    <MonarxReportDrawer
      isDrawerOpen={isReportDrawerOpen}
      closeDrawer={closeReportDrawer}
      addonId={addonId!}
      siteId={isListPage ? undefined : siteInfo?.id ?? ''}
      upgradeBtnText={t('upgradePlanBtn')}
      currentPlan={planNameLower}
      domainName={domainName ?? ''}
    />
  ); */

  /*   const hasMonarxBanners = showThreatshieldBanner || showMalwareUpgradeBanner;
  const showMonarxInOverviewTopCap =
    !wouldSiteDomainActionsShow && hasMonarxBanners; */

  const siteDomainActions = !isListPage && (
    <SiteDomainActions
      siteInfoOverride={siteInfo}
      isListView={false}
      isAutogenPendingURL={isAutogenPendingURL}
      pendingDomainIsNotPointed={!domainUpdateInProgress}
      sitesDomainLoading={sitesDomainLoading}
      onShouldShowManageButton={onShouldShowManageButton}
    />
  );

  /*   const malwareIcon = (
    <ErrorOutlineIcon sx={{ color: MALWARE_ERROR_STYLE.accentColor }} />
  );

  const bannerTitle = isListPage
    ? t('titleWithDomain', { domain: domainName ?? '' })
    : t(`${planName}ForBH`);
 */
  /*   const handleChatNow = () => {
    if ((window as any)['Genesys']) {
      return (window as any)['Genesys']('command', 'Messenger.open');
    }
    return openInNewTab(contactLink);
  }; */

  if (wouldSiteDomainActionsShow && !isListPage) {
    return <>{siteDomainActions}</>;
  }

  /* if (showThreatshieldBanner && showMonarxInOverviewTopCap && bannerTitle) {
    return (
      <>
        <CardTopBanner
          title={bannerTitle}
          icon={malwareIcon}
          {...SEVERITY_COLORS.error}
          actions={[
            {
              label: t('viewThreatsBtn'),
              variant: 'text',
              onClick: openReportDrawer,
            },
            {
              label: t('contactSupportBtn'),
              variant: 'outlined',
              onClick: handleChatNow,
            },
          ]}
        />
        {reportDrawer}
      </>
    );
  } */

  /* if (showMalwareUpgradeBanner && showMonarxInOverviewTopCap && bannerTitle) {
    return (
      <CardTopBanner
        title={bannerTitle}
        icon={malwareIcon}
        {...SEVERITY_COLORS.error}
        actions={[
          {
            label: t('upgradePlanBtn'),
            variant: 'outlined',
            type: CardActionType.MONARX_FAMILY,
          },
        ]}
        ctbData={{
          currentPlan: planNameLower,
          domainName: domainName ?? '',
          parentProdInstId: hostingId ?? '',
          prodInstId: accountBackRef ?? hostingId ?? '',
          productName: MONARX_FAMILY,
        }}
      />
    );
  } */

  return null;
};

export default OverviewTopCap;
